import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogActions,
  DialogContent,
} from 'components/common/Dialog';
import Button from 'components/common/Button';

import { accountLogout } from 'redux/modules/account';

const styles = () => ({
  message: {
    padding: '60px 85px',
  },
  subheading: {
    marginBottom: 17,
  },
});

const AccountLogoutDialog = props => (
  <Dialog
    open={props.open}
    onClose={props.onClose}
    maxWidth="sm"
  >
    <DialogContent>
      <div className={props.classes.message}>
        <Typography
          className={props.classes.subheading}
          variant="subheading"
        >
          Are you sure that you want to log out?
        </Typography>
        <Typography color="secondary">
          Сaution: this can not be undone
        </Typography>
      </div>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={props.onClose}
        variant="raised"
        color="primary"
      >
        Cancel
      </Button>
      <Button
        onClick={() => props.actions.accountLogout()}
        variant="raised"
      >
        Log Out
      </Button>
    </DialogActions>
  </Dialog>
);

AccountLogoutDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  actions: PropTypes.shape({
    accountLogout: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    message: PropTypes.string.isRequired,
    subheading: PropTypes.string.isRequired,
  }).isRequired,
};

AccountLogoutDialog.defaultProps = {
  open: false,
  onClose: () => {},
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLogout }, dispatch),
});

export default withRouter(
  connect(null, mapDispatchToProps)(withStyles(styles)(AccountLogoutDialog)),
);



// WEBPACK FOOTER //
// ./src/components/account/AccountLogoutDialog/AccountLogoutDialog.js